<template>
  <App container-class="app-container--guest">
    <template #after>
      <Modals />
    </template>
  </App>
</template>
<script setup>
import App from "@/js/Components/Layout/App.vue";
import Modals from "@/js/Components/Modal/Modals.vue";
</script>